import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "wrapper",
  class: "chart-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "chart-box box"
}
const _hoisted_3 = { class: "chart-header" }
const _hoisted_4 = { class: "chart-title" }
const _hoisted_5 = { class: "title is-size-5 mb-0" }
const _hoisted_6 = { class: "has-text-grey is-size-6 ml-1" }
const _hoisted_7 = { class: "chart-actions" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mdi is-size-5 mdi-help-circle-outline" }, null, -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "mdi is-size-5 mdi-reload" }, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "chart-content" }
const _hoisted_13 = { ref: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_popover = _resolveComponent("n-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.indicator)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(_ctx.indicator.unit) + ")", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.indicator.description)
                ? (_openBlock(), _createBlock(_component_n_popover, {
                    key: 0,
                    placement: "bottom-end",
                    trigger: "hover"
                  }, {
                    trigger: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "button is-light is-small is-rounded mr-1",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.chart.resetZoom()))
                      }, _hoisted_9)
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" " + _toDisplayString(_ctx.indicator.description), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_n_popover, {
                placement: "bottom-end",
                trigger: "hover"
              }, {
                trigger: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "button is-light is-small is-rounded",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.chart.resetZoom()))
                  }, _hoisted_11)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('chart.reset')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("canvas", _hoisted_13, null, 512 /* NEED_PATCH */), [
              [_vShow, !_ctx.loading]
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}